import { captureException } from "@sentry/react";
import { useEffect, useState } from "react";
import http from "services/https";

export function useReport(start, end, params = {}) {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [report, setReport] = useState();

  const [processedParams, setProcessedParams] = useState(false);

  useEffect(() => {
    const currentKeys = processedParams ? Object.keys(processedParams) : [];
    const newKeys = typeof params === "object" ? Object.keys(params) : [];
    if (currentKeys.length < 1 && newKeys.length < 1) {
      if (!processedParams) {
        setProcessedParams({});
      }
      return;
    }

    if (newKeys.length < 1) {
      setProcessedParams({});
      return;
    }

    if (newKeys.length !== currentKeys.length) {
      setProcessedParams(params);
      return;
    }

    if (currentKeys.every((k) => processedParams[k] === params[k])) {
      return;
    }

    setProcessedParams(params);
  }, [params, processedParams]);

  useEffect(() => {
    let skip = false;
    setIsLoading(true);
    setIsError(false);

    if (!processedParams) {
      return;
    }

    (async () => {
      try {
        const req = await http.get(`reports/get`, {
          ...processedParams,
          start: typeof start === "number" ? new Date(start * 1000) : start,
          end: typeof end === "number" ? new Date(end * 1000) : end,
        });
        if (!req.data.report) {
          throw new Error("missing report");
        }
        if (!skip) {
          setReport(req.data.report);
        }
      } catch (e) {
        console.error("failed to load report:", e);
        captureException(e);
        if (!skip) {
          setIsError(true);
        }
      } finally {
        if (!skip) {
          setIsLoading(false);
        }
      }
    })();
    return () => {
      skip = true;
    };
  }, [start, end, processedParams]);

  return { report, isLoading, isError };
}
